import store from "@/store";
import Campaign from "@/views/Campaign";
import History from "@/views/History";
import Home from "@/views/Home";
import Prices from "@/views/Prices";
import Products from "@/views/Products";
import Buy from "@/views/Buy";
import CookiesPolitics from "@/components/CookiesPolitics/index";
import TermsAndConditions from "@/components/TermsAndConditions/index";
import PrivacyPolitics from "@/components/PrivacyPolitics/index";
import Vue from "vue";
import VueObserveVisibility from "vue-observe-visibility";
import VueRouter from "vue-router";

Vue.use(VueRouter);
Vue.use(VueObserveVisibility);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/cb-",
    name: "Home",
    component: Home,
  },
  {
    path: "/cb-comercial",
    name: "Campaign",
    component: Campaign,
  },
  {
    path: "/cb-historia",
    name: "History",
    component: History,
  },
  {
    path: "/cb-premios",
    name: "Prices",
    component: Prices,
  },
  {
    path: "/cb-productos",
    name: "Products",
    component: Products,
  },
  {
    path: "/cb-donde-comprar",
    name: "Buy",
    component: Buy,
  },
  {
    path: "/cookies",
    name: "cookiesPolitics",
    component: CookiesPolitics,
  },{
    path: "/politics",
    name: "privacyPolitics",
    component: PrivacyPolitics,
  },{
    path: "/tycos",
    name: "termsAndConditions",
    component: TermsAndConditions,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  store.commit("closeLayoutNav");
  store.commit("closeAviso");
  store.commit("closeTycos");
  store.commit("closeCookies");
  store.commit("closeModal");
  next();
});

export default router;
